import axios from "axios";
import AuthorizationError from "../errors/AuthorizationError";

const client = axios.create({
  // TODO:
  // baseURL: process.env.NEXT_PUBLIC_API_URL,
  // baseURL: "http://localhost:8000",
  // baseURL: "http://18.178.232.58",
  baseURL: "https://lumier-dx.com",
});

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("access-token");
  if (token) {
    config.headers.Authorization = `JWT ${token}`;
  }
  return config;
});

client.interceptors.response.use(
  (res) => res,
  (err) => {
    switch (err.response?.status) {
      case 401: // authorization error
      case 403: {
        // authentication error
        const token = localStorage.getItem("access-token");
        if (token) {
          localStorage.removeItem("access-token");
        }
        return Promise.reject(new AuthorizationError("認証エラー"));
      }
      default:
        return Promise.reject(err);
    }
  },
);

export default client;
